const mutations = {
    // 前面两个路由
    addTab(state, componentName) {
        state.openedTab.push(componentName);
    },
    changeTab(state, componentName) {
        state.activeTab = componentName;
    },

    // 设置用户数据
    setUserInfo(state, data) {
        state.userInfo = data;
    },
    // 清除用户数据
    clearUserInfo(state) {
        state.userInfo = {
            token: '',
            user: {}
        };
    },

    // brian 2022 04 23
    SET_CURRENT_SYSTEM_MENU(state, data) {
        state.CURRENT_SYSTEM_MENU = data;
    },
    SET_USERINFO: (state, data) => {
        const { scope, user, switchScope = [] } = data;
        state.userInfo = { scope, user, switchScope };
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar || '';
    },
    SET_USER_TYPE(state, type) {
        state.type = type;
    },
    // 账号改造：存储用户类型（PERSONAL / ENTERPRISE / ENTERPRISE_ROOT）
    SET_ACCOUNT_USER_TYPE(state, userType) {
        state.accountUserType = userType;
    },
    SET_TREE_DATA(state, data) {
        state.SchemaTree = data || [];
    },
    // 记录当前树数据对应的用户ID，用于路由守卫检测用户切换
    SET_TREE_USER_ID(state, userId) {
        state.treeUserId = userId || null;
    },

    SET_UNIT(state, data) {
        state.unit = data;
    },
    SET_CARRIER_TYPE(state, data) {
        state.carrierType = data;
    },
    // Roasilan 2023 07 04
    SET_AUTH(state, data) {
        state.auth = data;
    },
    // Roasilan 2023 08 18
    SET_EX_TYPE(state, data) {
        state.exType = data;
    },
    // Roasilan 2023 10 12
    SET_CARRIER_MODE(state, data) {
        state.carrierMode = data;
    }
};
export default mutations;
